import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('de');

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setLanguage(user.language || 'de');
      } catch (e) {
        setLanguage(navigator.language?.startsWith('de') ? 'de' : 'en');
      }
    } else {
      // Default to German for non-logged-in users (StoryTales is primarily German)
      setLanguage(navigator.language?.startsWith('de') ? 'de' : 
                  navigator.language?.startsWith('en') ? 'en' : 'de');
    }
  }, []);

  const content = {
    de: {
      title: '404 - Seite nicht gefunden',
      subtitle: 'Ups! Diese Seite existiert nicht.',
      description: 'Die Seite, die Sie suchen, wurde möglicherweise verschoben, gelöscht oder hat nie existiert.',
      homeButton: 'Zur Startseite',
      contactButton: 'Kontakt aufnehmen'
    },
    en: {
      title: '404 - Page Not Found',
      subtitle: 'Oops! This page doesn\'t exist.',
      description: 'The page you\'re looking for might have been moved, deleted, or never existed.',
      homeButton: 'Go to Homepage',
      contactButton: 'Contact Us'
    }
  };

  const t = content[language] || content.en;

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">📖</div>
        <h1 className="not-found-title">{t.title}</h1>
        <p className="not-found-subtitle">{t.subtitle}</p>
        <p className="not-found-description">{t.description}</p>
        
        <div className="not-found-actions">
          <Button 
            onClick={() => navigate('/')}
            className="not-found-button primary"
          >
            {t.homeButton}
          </Button>
          <Button 
            onClick={() => navigate('/contact')}
            variant="outline"
            className="not-found-button secondary"
          >
            {t.contactButton}
          </Button>
        </div>

        <div className="not-found-suggestions">
          <h3>{language === 'de' ? 'Beliebte Seiten:' : 'Popular Pages:'}</h3>
          <ul>
            <li><a href="/">{language === 'de' ? 'Startseite' : 'Home'}</a></li>
            <li><a href="/pricing">{language === 'de' ? 'Preise' : 'Pricing'}</a></li>
            <li><a href="/contact">{language === 'de' ? 'Kontakt' : 'Contact'}</a></li>
            <li><a href="/impressum">Impressum</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
